import {OrderProvider} from 'providers/OrderProvider'
import {useMemo} from 'react'
import {getOrderActivityDetails} from 'utils/getOrderActivityDetails'

export const useOrderActivityDetails = () => {
  const order = OrderProvider.useOrder()
  return useMemo(() => getOrderActivityDetails(order), [order])
}
